module.exports = __webpack_public_path__ + "img/celebration.d655960f.png";